import React from 'react';
import PropTypes from 'prop-types';

import FluidContainer from '../layouts/components/fluid-container';

import Spacer from '../spacer';

const directions = {
    vertical: 'column',
    horizontal: 'row',
};

const getDirections = (directionProp) => {
    if (Array.isArray(directionProp)) {
        return directionProp.map((direction) => directions[direction]).filter((x) => x);
    } else {
        return directions[directionProp];
    }
};

const Stack = ({ children, direction = 'vertical', gap = 'none', width }) => {
    const [firstItem, ...items] = React.Children.toArray(children);

    return (
        <FluidContainer width={width} flexDirection={getDirections(direction)} flexGrow={width ? 0 : 1}>
            {firstItem}
            {items.map((item, index) => (
                <React.Fragment key={index}>
                    <Spacer size={gap} />
                    {item}
                </React.Fragment>
            ))}
        </FluidContainer>
    );
};

Stack.propTypes = {
    children: PropTypes.node.isRequired,
    direction: PropTypes.oneOfType([PropTypes.oneOf(['vertical', 'horizontal']), PropTypes.array]),
    /** See theme space tokens specifications. */
    gap: PropTypes.oneOf(['none', 'xxs', 'xs', 'small', 'median', 'base', 'medium', 'regular', 'large', 'xl', 'xxl', 'desktop']),
    /** Fixed width in px to override default flex container grow. */
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['auto', 'max-content', 'min-content', 'fit-content'])]),
};

export default Stack;
